/**
 * This file was auto-generated using @dmp/mono-tools:changelog-converter and should not be manually edited.
 */

import type { PublicChangelogConfig } from '@dmp/shared/public-changelog';

export const publicChangelogConfig = {
    localStorageKey: 'feedr-client-public-changelog',
    releases: [
        
        {
            version: '1.5.0',
            date: '2025-10-02',
            changes: {
                added: ["Add indicator for working environment (Local, Beta, Dev,..) (GCCDEV-6125).","Entra ID authentication support (GCCDEV-1409)."],
                changed: ["Updated to React 19 (GCCDEV-6294).","Updated to NX 21 and Typescript 5.7.3 (GCCDEV-6100).","Node.js 22 support (GCCDEV-5719)."],
                fixed: undefined,
                deprecated: undefined,
                removed: undefined,
            },
        },

        {
            version: '1.4.0',
            date: '2024-10-14',
            changes: {
                added: undefined,
                changed: ["New release with post-Quay changes."],
                fixed: undefined,
                deprecated: undefined,
                removed: undefined,
            },
        },

        {
            version: '1.3.0',
            date: '2023-06-21',
            changes: {
                added: undefined,
                changed: undefined,
                fixed: ["Use consume api route from BE instead of FE to avoid caching (GCCDEV-3783).","Support period (.) character in column name (GCCDEV-3842).","Update Recoiljs to 0.7.5 to fix browser's new setTimeout behavior (GCCDEV-4110).","Replace react-query with @tanstact/react-query (GCCDEV-4505)."],
                deprecated: undefined,
                removed: undefined,
            },
        },

        {
            version: '1.2.0',
            date: '2022-03-22',
            changes: {
                added: ["Tooltip on wildcard consume filtering."],
                changed: undefined,
                fixed: ["Remove incorrect field validation for Entry Add Form."],
                deprecated: undefined,
                removed: undefined,
            },
        },

        {
            version: '1.1.0',
            date: '2022-03-10',
            changes: {
                added: ["Allow Feed name to be updated.","Input to adjust max number of results returned from consume route."],
                changed: undefined,
                fixed: undefined,
                deprecated: undefined,
                removed: undefined,
            },
        },
        ],
} satisfies PublicChangelogConfig;